var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12.334 1.646 10h3.129l-.696 2.334H1zm1.59 10.083L5.37 10h10.084l-2.832 12.417h-2.98l2.434-10.083H8.003L5.768 22.417H2.59zm12.516-7.6 2.533 6.06 1.092-4.917-2.583-5.662-1.044 4.52zM20.868 10l-2.633 12.07v.347h6.705c.828-.215 2.653-.795 3.328-1.39.676-.597 1.01-1.408 1.093-1.739h.895l.397-1.242H29.46c-.016-.397-.178-1.261-.695-1.54a15.585 15.585 0 0 0-1.39-.645c.363-.148 1.181-.516 1.539-.794.358-.278.58-.612.646-.745h1.092l.348-1.39h-.993c.033-.53-.269-1.768-1.739-2.483-.874-.358-1.523-.447-1.738-.447h-5.663zm2.533 2.285-.546 2.583h1.838c.076-.015.16-.025.252-.036.547-.065 1.312-.156 1.586-1.306.198-.834-.646-1.175-1.093-1.241h-2.036zm-1.092 4.818-.745 3.08H23.4c.07-.014.166-.025.28-.039.76-.09 2.344-.276 2.473-1.7.1-1.106-1-1.267-1.471-1.336l-.04-.005h-2.334z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTnb);
export default __webpack_public_path__ + "static/media/TNB.ee6d1bd612dd9d09f18b57c226ceb7b7.svg";
export { ForwardRef as ReactComponent };